import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'g10-pickup-point-rostering',
  templateUrl: './pickup-point-rostering.component.html',
  styleUrls: ['./pickup-point-rostering.component.css']
})
export class PickupPointRosteringComponent implements OnInit {

  @Input('formData') routeInfo;
  @ViewChild('modalShow') modalShow;
  @ViewChild('modalHide') modalHide;
/* user Info */
  public userData;

/* api objects */
  public routeObj = [];
  public vehicleObj = [];      
  public employeeObj = [];

/* route employees */
  public routeEmployees=[];

/* modal form */
  public modalForm:FormGroup;
  public loadForm:boolean=true;
  public fieldOptions = [{
    attendance:['OTP','Beacon','Wifi','RFID'],
  }];

/* vehicle Table Data */
  public vehicleTableData=[];

/* vehicle Info */
  public vehicleID='';
  public availableCapacity;

/* pickup points */
  public pickupPoints={};
  public editPickup:boolean=false;
  public selectedIndex;

/* active table row*/
  public activeVehicle=[];
  public activeIndex;

/* Employee table */
  public filteredList=[];
  public tableView:boolean=false;
  public tableObj = [];
  public tableDataType = 'employeeTable';
  public tableCols = [
    { key: "select", display: "" },
    { key: "empRefID", display: "Employee Id" },
    { key: "name", display: "Name" },
    { key: "location", display: "Area" },
  ];
  public employeeBtnClicked:boolean=false;
  public selectedEmpCount;
  public selectedEmployee=[];

/* Location */
  public getVehicleLocation:boolean;
  public vehicleLocation={};
  public pickupLocation={};
  public myMap: any = this.map.retMap();
  public locationSuggestions={};
  public searchInput: any = new Subject<string>();
  public destroy$: any = new Subject();
  public locationType='';

/* ETA */
  public eta = { hour: 0, minute: 0, meriden: 'AM', format: 12};
  public kmEst;

  constructor(
    private api: ApiService,
    private fb: FormBuilder,
    private storage: StorageService,
    private route: RouteService,
    private map: MapService,)
    {
    this.userData = this.storage.get('userInfo')
  }
  ngOnInit(){
    this.addFormLoad();
    this.getVehicleObj();
    this.getRouteObj();
    this.getEmployeeObj();

    this.loadMap();
    this.myMap.mymap.onMapClick((e: any) => {
      this.locationSuggestions = [];
      this.getGeoCode({ key: 'mapclick', val: e.lngLat.lng + ',' + e.lngLat.lat });
    });

    this.searchInput.pipe(takeUntil(this.destroy$), debounceTime(500), distinctUntilChanged()).subscribe(async (value) => {
      if (value.val.target.value != '') {
        this.getGeoCode(value);
      } else if (value.val.target.value.trim() == '') {
          if(this.getVehicleLocation) this.emptySuggestions('vehicleLocation');
          else this.emptySuggestions('pickupLocation');
      }
    });
  }

/* API Call*/
  getRouteObj() {
    let obj = {
      orgID: this.userData.orgID,
    };
    this.api.transportMangerRouteList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.routeObj=res.data;
      } else {
        console.log('else', res);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getVehicleObj(){
    let obj = {
      orgID: this.userData.orgID,
    }
    this.api.transportManagerVehicleList(obj).then((res:any)=>{
      if (res.status == 'success') {
      this.vehicleObj=res.data;
      this.setVehicleTable();         // set vehicle obj data to table data
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  getEmployeeObj(){
    let obj = {
      orgID: this.userData.orgID,
    }
    this.api.transportManagerEmployeeList(obj).then((res:any)=>{
      if (res.status == 'success') {
      this.employeeObj=res.data;
      this.getEmployeeData();         // get shiftwise employee list
      }
    }).catch((err) => {
      console.log(err)
    })
  }  

/* add form load */
  addFormLoad(){
    this.modalForm=this.fb.group({
      title:['',[Validators.required]],
      location:['',[Validators.required]],
      ETA:['',[Validators.required]],
      radius:['',[Validators.required]],
      attendance:['',[Validators.required]],
      status:['',[Validators.required]],
      employees:['',[Validators.required]],
    });
  }

/* edit form load */
  editFormLoad(data){
    this.modalForm.patchValue({
      title:data.title,
      location:data.location,
      ETA:data.ETA,
      radius:data.radius,
      attendance:data.attendance,
      status:data.status,
      employees:data.employees
    });
  }

/* set vehicle data for table */
  setVehicleTable(){
    let vehicleList=[];             //selected vehicles
    this.vehicleTableData=[];

    this.vehicleObj.filter((vehicle)=>{
      this.routeInfo.vehicles.filter((veh)=>{
        if(vehicle.vehicleID==veh){
          if(vehicleList.indexOf(veh)==-1) vehicleList.push(vehicle);
        }
      });
    });

    vehicleList.filter((element)=>{
      let obj={
        vehicleID:element.vehicleID,
        vehRegNo:element.vehRegNo,
        type:element.model,
        capacity:Number(element.capacity),
        attendance:"Otp",
        status:element.status,
      }
      this.vehicleTableData.push(obj);
    })
  }

/* Modal */
  modalOpen(vehicleID){
    this.loadForm=true;
    this.tableView=true;
    this.resetForm();
    this.loadMap();
    this.vehicleID=vehicleID;
    this.checkCapacity();
    if( this.availableCapacity > 0 ){
      if(this.pickupPoints[vehicleID]) this.getVehicleLocation=false;
      else this.getVehicleLocation=true;
      this.modalShow.nativeElement.click();
    }
  }
  modalClose(){
    this.loadForm=false;
    if(!this.editPickup){
      if(this.modalForm.valid) this.submitForm();
      else this.resetForm();
    }
    else{
      this.resetForm();
    }
    this.modalHide.nativeElement.click();
  }

/* checking capacity for add more pickup point to one vehicle*/
  checkCapacity(){
    let currentVehicle=this.vehicleTableData.filter((vehicle)=>vehicle.vehicleID==this.vehicleID);
    let capacity=currentVehicle[0].capacity;
    let employeeCount=0;
    if(this.pickupPoints && this.pickupPoints[this.vehicleID]){
      let employees=[];
      this.pickupPoints[this.vehicleID].filter((pickup)=>{
        pickup.employees.filter((emp)=>{
          if(employees.indexOf(emp)==-1) employees.push(emp);
        })
      })
      employeeCount=this.getEmployeeCount(employees,'all');
    }
    this.availableCapacity=capacity-employeeCount;
  }
/* get Employee counts */
  getEmployeeCount(data,gender){
    let employees=[];
    let count=0;
    this.employeeObj.filter((employee)=>{
      data.filter((emp)=>{
        if (employee.employeeID==emp){
          if (employees.indexOf(employee)==-1) employees.push(employee);
        }
      });
    });
    if(gender=='all') return employees.length;
    else{
      employees.filter((employee)=>{
        if(employee.gender==gender) count+=1;
      });
      return count;
    }
  }
  totalEmployeeCount(vehicleID,gender){
    let employeeCount=0;
    if(this.pickupPoints && this.pickupPoints[vehicleID]){
      let totalEmployees=[];
      this.pickupPoints[vehicleID].filter((pickup)=>{
        pickup.employees.filter((emp)=>{
          if(totalEmployees.indexOf(emp)==-1) totalEmployees.push(emp);
        })
      })
      employeeCount=this.getEmployeeCount(totalEmployees,gender);
    }
    return employeeCount;
  }

/* get Employee list based on radius and location*/

  getEmployeeList(obj,location,radius){
    return new Promise(async(resolve,reject)=>{
    let employees=[];
    let result=await this.route.findEmpbyRadius(obj,location,radius);
    employees.push(result);
    this.tableObj.map((employee,index)=>{
      employees.filter((emp)=>{ 
        if(employee.employeeID!=emp){
          this.tableObj.splice(index,1);
        }
      })
      if(this.tableObj.length-1==index) resolve(this.tableObj);
      })
    })
  }

/* get Eta and KM Estimation based on two locations*/
  getKmEst(previousLocation,currentLocation){
    return new Promise(async(resolve,reject)=>{
    let result=await this.route.findETADist(previousLocation,currentLocation)
    resolve(result['Distance']);
    })
  }

/* get total for table view */
  totalKmEst(vehicleID){
    let kmEst=0;
    if(this.pickupPoints && this.pickupPoints[vehicleID]){
      this.pickupPoints[vehicleID].filter((element)=>{
        kmEst+=element.kmEst;
      })
    }
    return kmEst;
  }
  totalPickupCount(vehicleID){
    let pickupCount=0;
    if(this.pickupPoints && this.pickupPoints[vehicleID]){
      pickupCount=this.pickupPoints[vehicleID].length;
    }
    return pickupCount;
  }

/* Expand Table */
  expandMore(event,vehicleID,index){
    event.stopPropagation();
    if(this.pickupPoints && this.pickupPoints[vehicleID]){
      this.activeVehicle=this.pickupPoints[vehicleID];
      this.activeIndex=index;
    }
  }
  expandLess(event){
    event.stopPropagation();
    this.activeIndex=undefined;
    this.activeVehicle=[];
  }

/* Location */
  loadMap(marker: any = []) {
    this.map.loadMap('pickuppoint', marker);
  }
  typeOfLocation(type){
    this.locationType=type;
    this.tableView=false;
  }
  getGeoCode(value) {
    const key = value.key;
    this.locationSuggestions[key] = [];
    this.myMap.mymap.geocoder(value.val, (res) => {
      try {   
        const result = res.features.map((i) => ({ lat: i.center[1],lng: i.center[0], name: i.place_name }));
        if (key == 'mapclick') {
          this.locationSuggestions = {};
          if(this.locationType=='vehicleLocation'){
            this.vehicleLocation=result[0];
          }
          else if(this.locationType=='pickupLocation'){
            this.pickupLocation=result[0];
            this.modalForm.controls.location.patchValue(this.pickupLocation);
            this.setKmEst();
          }
        } else {
          this.locationSuggestions[key] = result;
        }
      } catch (er) { console.log(er); }
    });
  }

  emptySuggestions(locationType) {
    this.locationSuggestions = {};
    if(this.tableView){
      this.tableView=false;
      this.loadMap();
    }
    if(locationType=='pickupLocation'){
      this.pickupLocation={};
      this.modalForm.controls.location.patchValue('');
    }
    else{
      this.vehicleLocation={};
    }
  }

/* Time picker value patch */
  onChangeHour(event) {
    let timevalue=this.setTimeString(event)
    this.modalForm.controls.ETA.patchValue(timevalue);
    if(Number(event.minute)<10) event.minute=event.minute.substring(1);
    this.eta = event;
  }
  setTimeString(time){
    let timeString=time.hour+':'+time.minute+' '+time.meriden;
    return timeString;
  }
  editTimeString(time){                             // time '10:20 AM'
    let timeString=time;
    let splitTime=timeString.split(":");            // 10, 20 AM
    let splitMinute = splitTime[1].split(' ');      // 20, AM
    let hour=splitTime[0];
    let minute=splitMinute[0];
    let meriden=splitMinute[1];
    if(Number(minute)<10) 
      minute=minute.substring(1);
    let timeformat = { hour: hour, minute: minute, meriden: meriden, format: 12 };
    return timeformat;
  }

/* form field value Changes */
  async fieldChange(field,type,event){
    if(type=='number'){
      if(this.modalForm.value.location){
        let location=this.modalForm.value.location;
        if(event){
          let radius=event;
          let employees =await this.getEmployeeList(this.tableObj,location,radius);
          console.log('employees',employees);
        }
        else this.modalForm.controls.radius.markAsTouched();
      }
      else this.modalForm.controls.location.markAsTouched();
    }
    if(type=='tableBtn'){
      this.tableView=true;
    }
    if(type=='dropdown'){
      this.modalForm.controls[field].patchValue(event.value);
    }
  }

/* Get Employee Table */
  getEmployeeData(){
    let selectedShift=this.routeInfo.routeShift;
    let filteredEmployees=this.employeeObj.filter((emp)=>emp.shift==selectedShift);
    // checking already assigned employee list
    /* this.routeObj.filter((route)=>{
      route.employees.filter((emp)=>{
        filteredEmployees.filter((element,index)=>{
          if(emp==element.employeeID){
            filteredEmployees.splice(index,1);
          }
        })
      })
    }) */
    if(this.routeEmployees){
      this.routeEmployees.filter((emp)=>{
        filteredEmployees.filter((employee,index)=>{
          if(emp==employee.employeeID){
            filteredEmployees.splice(index,1);
          }
        })
      })
    }
    this.filteredList=filteredEmployees;
    this.tableObj=this.filteredList;
 }

/* selected Employee data from table */
 selectedTableData(e){
   this.employeeBtnClicked=true;
   this.selectedEmployee=e.data;
   this.selectedEmpCount=e.data.length;
   if(e.data.length==0){
     this.modalForm.controls.employees.patchValue(null);
    }
    else{
     let list=[];
     e.data.filter((emp)=>list.push(emp.employeeID));
     this.modalForm.controls.employees.patchValue(list);
   }
 }
/* set pickup point for particular vehicle */
 setPickupPoints(){
  if(this.pickupPoints[this.vehicleID]==undefined){
    this.pickupPoints[this.vehicleID]=[];
    let obj={
      ...this.modalForm.value,
      kmEst:this.kmEst,
      vehicleLocation:this.vehicleLocation,
    }
    this.pickupPoints[this.vehicleID].push(obj);
  }
  else{
    let index=this.pickupPoints[this.vehicleID].length-1;
    let previousLocation = this.pickupPoints[this.vehicleID][index].location;
    let obj={
      ...this.modalForm.value,
      kmEst:this.kmEst,
      previousLocation:previousLocation,
    }
    this.pickupPoints[this.vehicleID].push(obj);
  }
 }

/* edit pickup points */
  editPickupPoint(vehicleID,i){
    console.log(vehicleID,i);
    this.editPickup=true;
    this.vehicleID=vehicleID;
    this.selectedIndex=i;
    let obj=this.pickupPoints[vehicleID][i];
    this.checkCapacity();
    this.getEmployeeData();
    this.editFormLoad(obj);
    this.eta=this.editTimeString(obj['ETA']);
    this.kmEst=obj['kmEst'];
    if(i==0) {
      this.getVehicleLocation=true;
      this.vehicleLocation=obj['vehicleLocation'];
    }
    this.pickupLocation=obj['location'];
    this.employeeBtnClicked = true;
    this.selectedEmpCount=obj['employees'].length;
    this.selectedEmployee=[];
    obj['employees'].filter((empID)=>{
      this.employeeObj.filter((employee)=>{
        if(employee.employeeID==empID) this.selectedEmployee.push(employee);
      });
    });
    this.selectedEmployee.filter((e)=>this.tableObj.push(e));
    this.tableView=false;
    this.loadMap();
    this.fieldChange('radius','number',obj['radius']);
    this.loadForm=true;
    this.modalShow.nativeElement.click();
  }

/* Delete Pickup point from vehicle*/
  deletePickupPoint(vehicleID,i){
    let obj=this.pickupPoints[vehicleID][i];
    obj['employees'].filter((emp)=>{
      this.routeEmployees.filter((employee,index)=>{
        if(emp==employee) this.routeEmployees.splice(index,1);
      })
    });
    console.log(this.routeEmployees);
    this.pickupPoints[vehicleID].splice(i,1);
    console.log(obj)
    if(this.pickupPoints[vehicleID].length>0){
      if(i==0){
        delete this.pickupPoints[vehicleID][0].previousLocation;
        this.pickupPoints[vehicleID][0]['vehicleLocation']=obj['vehicleLocation'];
      }
        this.kmEstCheck(vehicleID);
    }
    else{
      this.pickupPoints[vehicleID]=undefined;
      this.activeIndex=undefined;
      this.activeVehicle=[];
    }
    this.getEmployeeData();
  }

/* re-calculate kmEst */
  kmEstCheck(vehicleID){
    this.pickupPoints[vehicleID].filter(async (pickups,index)=>{
      if(index==0){
        pickups.kmEst=await this.getKmEst(pickups.vehicleLocation,pickups.location);
      }
      else{
        let previousLocation = this.pickupPoints[vehicleID][index-1].location;
        pickups.kmEst=await this.getKmEst(previousLocation,this.pickupLocation);
      }
    })
  }

/* store Km est when location picked */
  async setKmEst(){
    if(this.pickupPoints[this.vehicleID]==undefined){
      if(this.vehicleLocation){
        this.kmEst=await this.getKmEst(this.vehicleLocation,this.pickupLocation);
      }
    }
    else{
      let index=this.pickupPoints[this.vehicleID].length-1;
      let previousLocation = this.pickupPoints[this.vehicleID][index].location;
      this.kmEst=await this.getKmEst(previousLocation,this.pickupLocation);
    }
  }

/* submit pickup point form */
  submitForm(){
    if(this.modalForm.valid){
      this.modalForm.value.employees.filter((emp)=> this.routeEmployees.push(emp));
      console.log(this.modalForm.value);
      this.setPickupPoints();
      this.resetForm();
      this.getEmployeeData();
      console.log(this.pickupPoints);
    }
  }
/* update pickup point form*/
  updateForm(){
    if(this.modalForm.valid){
      let obj=this.pickupPoints[this.vehicleID][this.selectedIndex];
      //remove previous assisgned employees
      obj['employees'].filter((emp)=>{
        this.routeEmployees.filter((employee,index)=>{
          if(emp==employee) this.routeEmployees.splice(index,1);
        });
      });
      //add current assisgned employees
      this.modalForm.value.employees.filter((emp)=>{
          if(this.routeEmployees.indexOf(emp)==-1) this.routeEmployees.push(emp);
      })
      if(this.selectedIndex==0){
        let obj={ ...this.modalForm.value,
          kmEst:this.kmEst,
          vehicleLocation:this.vehicleLocation,
        };
        this.pickupPoints[this.vehicleID][this.selectedIndex]=obj;
      }
      else{
        let previousLocation = this.pickupPoints[this.vehicleID][this.selectedIndex-1].location;
        let obj={ ...this.modalForm.value,
          kmEst:this.kmEst,
          previousLocation:previousLocation,
        };
        this.pickupPoints[this.vehicleID][this.selectedIndex]=obj;
      }
      this.kmEstCheck(this.vehicleID);
      this.resetForm();
      this.getEmployeeData();
    }
  }

/* reset pickup point form */
  resetForm(){
    this.modalForm.reset();
    this.selectedEmpCount=undefined;
    this.employeeBtnClicked=false;
    this.kmEst=undefined;
    this.getVehicleLocation=false;
    this.vehicleLocation={};
    this.pickupLocation={};
    this.locationType='';
    this.locationSuggestions={};
    this.tableView=false;
    this.eta = { hour: 0, minute: 0, meriden: 'AM', format: 12};
    this.editPickup=false;
    this.modalHide.nativeElement.click();
  }

/* submit route */
  submit(){
    let obj={
      ...this.routeInfo,
    }
    obj['employees']=this.routeEmployees;
    obj['pickupInfo']=this.pickupPoints;
    console.log(obj);
  }
  
}



////////////////////////////////////////////////////////////////////////////////////////////////
/*

  Aim:
      In this manual add route module this is second page of the module
      getting vehicle information then show details in table view, 
      In the table view add pickup points for particular vehicle,
      then showing vehicle information along with their pickuppoints   
      (a single pickup point includes set of unique employees 
        In particular shift,location,ETA,etc., )

  steps:
      1.Get filled route information in this page using input decorator.
        (Route information having Title, Branch (id), Shift (id), Start-Time, 
         End-Time, Type, Vehicle (id's), Attendance, Status, IVR call connect)

      2.Get Route List, vehicle List,Employee List from API. 

      3.Using vehicle List retieve route information vehicle only for table View,

      4.In table row click event trigger modal to get individual pickuppoint data.
        get vehicle id from that row for future use.

      5.create form for getting pickup point data.
        ( form have these fields title,vehicle location, pickup point location, ETA, radius,
          attendance, status, employees)
      
      6.Getting pickup point location and radius.Filter the employees on that particular 
        location and also checking employee data not in any assigned routes and also checking
        any other assigned pickup points in this route then send data to table component
        to show and get the particular employees.

      7.In sending data to table component to show employees,also sending that particular
        vehicle capacity to pick only available seats then emitting the data and store it 
        In form field employee ( value consist employee id only)

      8.store selected employee id's in selectedEmployee variable and routeEmployee variable
        for further use,

      9.finally getting all modal form data and store it in pickupPoint object under their
        vehicle id, getting km estimation and eta using two different locations,store it 
        In pickup point obj along with modal form data.
        (pickup point obj have modal form data along with KmEst)
      
      10.close the modal when the pickup point form valid.

      11.calculate the total KmEst and capacity available in that particular vehicle.
         also calculate Male and Female and all employee counts for table view using
         pickup Point objects
      
      12.give edit and delete option for pickup points in table view.

      
  objects:

      1. routeInfo = {}        --> Route Information  - Input decorator
      2. routeObj = {}         --> Route Data from API
      3. vehicleObj = {}       --> Vehicle Data from API
      4. employeeObj = {}      --> Employee Data from API

      5. vehicleTableData = {} --> customized vehicle data for table view

      6. modalForm             --> formGroup

      7. selectedEmployee = {} --> sending selected employee list for edit route purpose
      8. routeEmployee = {}    --> store all pickup point employees for filter purpose

      9. pickupPointObj = {}   --> store pickup points obj under vehicleID as key

      10.finalObj = {}         --> store route information,pickup points,employees etc.,
      
  variable:

      1.vehicleID              --> getting unique vehicle id when row click event 
                                   triggers
  
  Api: 

      1.transportMangerRouteList(obj)
      2.transportManagerEmployeeList(obj)
      3.transportManagerVehicleList(obj)

  functions:

      1.addFormLoad()          --> load formGroup with fields and validation
      2.getRouteObj()          --> get route object from api
      3.getEmployeeObj()       --> get emloyee object from api
      4.getVehicleObj()        --> get vehicle object from api
      5.getVehicleTable()      --> get vehicles and customize the data for table
                                   view purpose   
                                
      6.getEmployeeData()      --> filter employees with routeObj and selected
                                   employees and send the final data to table 
                                   component

      7.selectedEmployeeData() --> get data from table component store selected 
        (param:data)               employee data in selected employee List and 
                                   routeEmployees

      8.getKmEst()             --> get km Estimation and ETA for in between two
        (param:2 locations)        pickup points

      9.getEmployees()         --> get employees from particular pickup point 
        (param:location,radius)    location 

      10.submitForm()          --> get modal form data and store it in pickup
                                   point Object
                                   
      11.resetForm()           --> reset modal form and all variables
      12.submit()              --> summery page moving along with all data
      etc.,

    
*/
////////////////////////////////////////////////////////////////////////////////////////////
